import  CommonImages, {
    createImage,
    computeImagePropsSize,
    isLogoAnImageURL,
} from '../../../../commons/images';

import { fixColor } from '../../../../commons/utils/strings';

export function withRoundLogoSample (widget) {
    return {
        ...widget,
        logo_shape: 'round',
        logo_shadow: true,
        logo: 'https://ecal-dynamic-assets.s3.us-east-1.amazonaws.com/assets/app/logo-round.svg',
        logo_transparent: true,
    };
}

export function withRectLogoSample (widget) {
    return {
        ...widget,
        logo: CommonImages.ECAL_LOGO_RECT,
    }
}

export function withDefaultBanner (data) {
    return {
        ...data,
        banner_type: 'solid',
        banner_colour:  data.banner_colour ||  data.primary_button_background,
        banner_url: '',
    };
}

export function computeLogoProps (widget, image) {
    if (image.aspectRatio === 'Invalid dimensions') {
        return widget;
    }

    const imageProps = {
        logoAspectRatio: image.aspectRatio,
        logoWidth: image.width,
        logoHeight: image.height,
    };

    let customProps = {};
    
    if (widget.hasOwnProperty('logoTransparent')) {
        customProps.logo_transparent = widget.logoTransparent;
    }

    if (widget.hasOwnProperty('logo_transparent')) {
        customProps.logo_transparent = widget.logo_transparent;
    }
    // change the logo position here also to avoid computation on state style updates
   
    if (widget.version === '1') {
        // v1
      
        if (image.aspectRatio === '1:1') {
            customProps = {
                logo_shape: 'round',
                logo_shadow: widget.logo_shadow || false,
            };
            
        } else {
            customProps = {
                logo_shape: 'rect',
                logo_shadow: widget.logo_shadow || false,
            };
        }

        if (image.virtualURL && !isLogoAnImageURL(widget)) {
           // only use virtualLogoURL  with actual API Logo URLS from legacy
           customProps.logo = image.virtualURL;
        }
    }

    if (widget.logo.indexOf('ecal-logo-round') !== -1 || customProps.logo) {
        imageProps.logoWidth = 80;
        imageProps.logoHeight = 80;
        imageProps.logoAspectRatio = '1:1';
    } else {
        computeImagePropsSize(image, imageProps);
    }

    return {
        ...widget,
        ...imageProps,
        ...customProps,
    };
}

function toCamelCase (data, snake, camel) {
    if (data[snake]) {
        data[camel] = data[snake];
        delete data[snake];
    }
} 

export function formalize (data) {
    const newData = {
        ...data,
    };

    toCamelCase(newData, 'banner_url', 'bannerURL');
    toCamelCase(newData, 'banner_type', 'bannerType');
    toCamelCase(newData, 'banner_colour', 'bannerColour');
    toCamelCase(newData, 'logo_shadow', 'logoShadow');
    toCamelCase(newData, 'logo_shape', 'logoShape');
    toCamelCase(newData, 'logo_transparent', 'logoTransparent');
    return newData;
}

function fixColors (widget) {
    fixColor(widget, 'primary_button_background');
    fixColor(widget, 'button_background');
    fixColor(widget, 'button_foreground');
    fixColor(widget, 'header_background');
    fixColor(widget, 'header_foreground');
    fixColor(widget, 'horizontal_line_background');
    fixColor(widget, 'primary_button_foreground');
    fixColor(widget, 'secondary_button_background');
    fixColor(widget, 'secondary_button_foreground');
}

async function injectDefaultsFallback (data) {
    // let newData = withImageBanner(data);
  
    let newData = data;
    let logo = newData?.logo;
    fixColors(newData);
    if (!logo) {
        newData = withRoundLogoSample(newData);
    }

    console.log('injectDefaultsFallback  pre-proccessing of NEW Data ', newData);
    if (newData?.logo) {
        const image = await createImage(newData.logo);
        newData = computeLogoProps(newData, image);
    }
    console.log('injectDefaultsFallback() computed NewData ', newData);

    if (!newData?.banner_type || !newData?.banner_url) {
        newData = withDefaultBanner(newData);
    }

    newData = formalize(newData);
    console.log('injectDefaultsFallback() finalized-widget: ', newData);
    return newData;
}

export default injectDefaultsFallback;
